import TwoAfricanWomenImage from "../../../assets/webp/business/twoafrican-businesswomen_converted.webp";
import BulletIcon from "../../../assets/icons/business/bullet.svg";
import { Link } from "react-router-dom";

export const VantPaymentSolutions = () => {
  return (
    <section className="w-full bg-[#112126] px-4 py-[6rem] md:px-10 lg:px-10 xl:px-32 ">
      <div className="mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Left Content */}
              <div className="flex flex-col justify-center h-full">
                  
          <div className="flex text-white font-[Urbanist] items-center border-[#32AE4C] border md:w-[40%] w-[60%] mb-[2rem] rounded-[2rem] p-[1rem]">
            <span className="h-2 w-2 bg-green-400 rounded-full mr-2"></span>
            Vant for businesses
          </div>

          <h2
            className="text-white text-4xl md:text-5xl font-[600] mb-8 leading-tight"
          >
            Payment Solutions for Business
          </h2>
          <p
            className="text-[#E6E6E6] text-lg mb-8 max-w-xl"
          >
            Our Services suit all Kinds of Business and All sizes, providing
            tailored support for;
          </p>
          <ul className="mb-12 space-y-5">
            <li
              className="flex items-center text-[#E6E6E6] text-lg gap-5"
            >
              <img src={BulletIcon} alt="" />
              Small startups to Large enterprises
            </li>
            <li
              className="flex items-center text-[#E6E6E6] text-lg gap-5"
            >
                <img src={BulletIcon} alt="" />
              Local Shops to Global cooperations
            </li>
            <li
              className="flex items-center text-[#E6E6E6] text-lg gap-5"
            >
                <img src={BulletIcon} alt="" />
              Online Marketplaces to brick-and-mortar stores
            </li>
          </ul>
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              className="bg-green-500 hover:bg-green-600 text-white text-lg font-semibold rounded-full px-10 py-4 transition-colors"
            >
              <Link
                to="https://business.vant.ng/login"
                target="_blank"
              >
              Get Started
              </Link>
            </button>
            <button
              className="border border-white text-white text-lg font-semibold rounded-full px-10 py-4 transition-colors hover:bg-white hover:text-[#112126]"
            >
              <Link
                to="mailto:support@vantapp.com"
                target="_blank"
              >
              
              Contact sale
              </Link>
            </button>
          </div>
        </div>
        {/* Right Image */}
        <div className="flex justify-center items-center">
          <div className="rounded-2xl overflow-hidden shadow-xl w-full max-w-xl">
            <img
              src={TwoAfricanWomenImage}
              alt="Business Payment Solutions"
              className="w-full h-[420px] md:h-[500px] object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
